// extracted by mini-css-extract-plugin
export default {"label":"Radio_label__WpAYC","checkedIcon":"Radio_checkedIcon__5AgCV","icon":"Radio_icon__Zf-au","root":"Radio_root__s4H7o"};